import "./skeleton.css";

export default function Skeleton({
  as: Component = "div",
  className = "",
  width,
  height,
  radius,
  style,
  ...props
}) {
  const mergedStyle = {
    width,
    height,
    borderRadius: radius,
    ...style,
  };

  return <Component className={`ui-skeleton ${className}`.trim()} style={mergedStyle} {...props} />;
}

export function SkeletonStack({ className = "", gap = 12, children, ...props }) {
  return (
    <div className={`ui-skeleton-stack ${className}`.trim()} style={{ gap }} {...props}>
      {children}
    </div>
  );
}
